<div id="images" class="my-5">
  <div class="container-fluid px-2 px-lg-5">
      <div class="row">
          <div class="col-12" data-scroll>
              <h2 class="font-weight-bold text-center">MPPS GALLERY</h2>
              <hr class=" p-1 opacity-100 mx-auto" style="width: 160px;">
              
          </div>
      </div>
      
      <owl-carousel-o [options]="customOptions">

          <ng-container *ngFor="let image of filterImage;let i = index">
            <ng-template carouselSlide >
              <div class="card shadow-lg  mx-3" id="{{image.$key}}"  (click)="openGalleryList(image.$key,image.caption)">
                   <img appLazyload class="card-img-top h-100" [src]="image.imgUrl" alt="Card image cap" >
                   <div class="card-body">
                     <a  >{{image.caption}} </a>
                   </div>
                   
                 </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      
     
  </div>
</div>








